import styled from 'styled-components'

interface IProps {
  display?: string
  top?: string
  right?: string
  bottom?: string
  left?: string
}
export const Margin = styled.div<IProps>`
    display: ${({ display }) => display ? display : 'block'};
    margin: ${props => props.top ? props.top : 0} ${props => props.right ? props.right : 0} ${props => props.bottom ? props.bottom  : 0} ${props => props.left ? props.left  : 0};
`